export const ActionsDots = ({ className }) => {
  return (
    <svg
      className={className}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.304688"
        y="0.566406"
        width="20"
        height="20"
        rx="10"
        fill="#070707"
      />
      <path
        d="M11.1354 4.73299C11.1354 4.27275 10.7623 3.89966 10.3021 3.89966C9.84185 3.89966 9.46875 4.27275 9.46875 4.73299C9.46875 5.19323 9.84185 5.56632 10.3021 5.56632C10.7623 5.56632 11.1354 5.19323 11.1354 4.73299Z"
        fill="white"
      />
      <path
        d="M11.1354 10.5663C11.1354 10.1061 10.7623 9.73299 10.3021 9.73299C9.84185 9.73299 9.46875 10.1061 9.46875 10.5663C9.46875 11.0266 9.84185 11.3997 10.3021 11.3997C10.7623 11.3997 11.1354 11.0266 11.1354 10.5663Z"
        fill="white"
      />
      <path
        d="M11.1354 16.3997C11.1354 15.9394 10.7623 15.5663 10.3021 15.5663C9.84185 15.5663 9.46875 15.9394 9.46875 16.3997C9.46875 16.8599 9.84185 17.233 10.3021 17.233C10.7623 17.233 11.1354 16.8599 11.1354 16.3997Z"
        fill="white"
      />
      <path
        d="M11.1354 4.73299C11.1354 4.27275 10.7623 3.89966 10.3021 3.89966C9.84185 3.89966 9.46875 4.27275 9.46875 4.73299C9.46875 5.19323 9.84185 5.56632 10.3021 5.56632C10.7623 5.56632 11.1354 5.19323 11.1354 4.73299Z"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1354 10.5663C11.1354 10.1061 10.7623 9.73299 10.3021 9.73299C9.84185 9.73299 9.46875 10.1061 9.46875 10.5663C9.46875 11.0266 9.84185 11.3997 10.3021 11.3997C10.7623 11.3997 11.1354 11.0266 11.1354 10.5663Z"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1354 16.3997C11.1354 15.9394 10.7623 15.5663 10.3021 15.5663C9.84185 15.5663 9.46875 15.9394 9.46875 16.3997C9.46875 16.8599 9.84185 17.233 10.3021 17.233C10.7623 17.233 11.1354 16.8599 11.1354 16.3997Z"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
